import clsx from 'clsx';
import styles from './FieldGroup.module.scss'

export default ({ className, children, collapse }) => (
  <div className={clsx(styles.group, className)}>
    <div className={styles.inner} data-collapse={collapse} >
      { children }
    </div>
  </div>
)
